import { render } from "./createOfertaCompra.vue?vue&type=template&id=2af585d2&scoped=true"
import script from "./createOfertaCompra.vue?vue&type=script&lang=js"
export * from "./createOfertaCompra.vue?vue&type=script&lang=js"

import "./createOfertaCompra.vue?vue&type=style&index=0&id=2af585d2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2af585d2"]])

export default __exports__